/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Chat_Own_DocumentsInputs */



/**
* | output |
* | --- |
* | "Chat with my own documents" |
*
* @param {Onboarding_Usage_Chat_Own_DocumentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_chat_own_documents = /** @type {((inputs?: Onboarding_Usage_Chat_Own_DocumentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Chat_Own_DocumentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit eigenen Dokumenten chatten")
	return /** @type {LocalizedString} */ ("Chat with my own documents")
});